import Flights from '@/api/flights';
import moment from 'moment'

const state = {
    items: [],
    airport: 'RIX',
    filter: {
        dayOfOrigin: moment(new Date()).utc().format('yyyy-MM-DD'),
    },
}

const getters = {
    availableAirports: state => state.items.map(f => [f.actualDepApIata, f.actualArrApIata]).flat().sort(),
}

const actions = {
    updateAndApplyFilter({commit, dispatch}, filter) {
        commit('setFilter', filter)
        dispatch('search')
    },
    updateFilter({commit}, filter) {
        commit('setFilter', filter)
    },
    setAirport({commit}, ap) {
        commit('setAirport', ap)
    },
    search({commit, state}) {
        return Flights.search(state.filter)
            .then(({ data }) => {
                commit('setItems', data)
            })
            .catch((err) => {
                console.log("failed to fetch flights " + err)
                commit('setItems', [])
            })
    }
}

// mutations
const mutations = {
    setFilter(state, filter) {
        state.filter = filter
    },
    setAirport(state, ap) {
        state.airport = ap
    },
    setItems(state, items) {
        state.items = items
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
